import { createEmitter } from "ts_utils";
import { Templates } from "../ui/Templates";
import { sidebarItem } from "../ui/templates/songMenuTemplates";

export class _SongsSidebar {
	private _ui:HTMLDivElement;
	
	private _categories:Array<_CategoryItem> = [];
	
	private _selectedCategory:_CategoryItem;
	
	public get event() { return this._emitter.event; }
	private _emitter = createEmitter<_SongSidebarEvent>();
	
	constructor(ui:HTMLDivElement){
		this._ui = ui;
	}
	
	public init():void {
		this._draw();
		
		this._selectedCategory = this._categories[0];
		this._updateSelection();
		this._dispatchRequest();
		
		this._addListeners();
	}
	
	/**call to dispatch an event that will request the songs reflecting the
	 * currently selected song category filter. In turn this will fire the
	 * [_SongSection]'s code to redisplay the songs.*/
	public dispatchSongDisplayRequest():void {
		this._dispatchRequest();
	}
	
	private _draw():void {
		let categoriesDiv = this._ui.querySelector(".m-sidebar-genresDiv");
		let categoriesJson = window['libraryCategories'] as any[];
		for (let c of categoriesJson){
			let item = new _CategoryItem(c['title'], c['catId']);
			item.ui = Templates.createDiv(sidebarItem);
			item.ui.innerHTML = c['title'];
			categoriesDiv.append(item.ui);
			this._categories.push(item);
		}
	}
	
	private _onCategoryClick = (e:MouseEvent):void => {
		this._selectedCategory = this._categories.find(c => c.ui === e.target);
		this._updateSelection();
		this._dispatchRequest();
	}
	
	private _updateSelection():void {
		this._categories.forEach((g) => {
			g.ui.classList.remove("m-selected");
			if (g === this._selectedCategory){
				g.ui.classList.add("m-selected");
			}
		});
	}
	
	private _dispatchRequest():void {
		let event = new _SongSidebarEvent();
		event.type = _SongSidebarEvent.CategoryRequest;
		event.categoryId = this._selectedCategory.categoryId;
		this._emitter.emit(event);
	}
	
	private _addListeners():void {
		this._categories.forEach((g) => {
			g.ui.addEventListener("click", this._onCategoryClick);
		});
	}
	
	private _removeListeners():void {
		this._categories.forEach((g) => {
			g.ui.removeEventListener("click", this._onCategoryClick);
		});
	}
}

class _CategoryItem {
	public name:string;
	public categoryId:string;
	public ui:HTMLDivElement;
	
	constructor(name:string, categoryId:string){
		this.name = name;
		this.categoryId = categoryId;
	}
}

export class _SongSidebarEvent {
	public type:string;
	public categoryId:string;
	
	public static readonly CategoryRequest:string = "categoryRequest";
}